import React, { Component } from 'react';
import { Link } from 'react-router-dom'
import './Header.scss';

export class Header extends Component {
  render() {
    return (
      <section className="">
        <header id="header">
          <div className="header-content clearfix">
            <Link className="logo" to='/home'>
              <h3>FerumSoft</h3>
            </Link>
            <nav className="navigation" role="navigation">
              <ul className="primary-nav">
                <li><a href="#features">Features</a></li>
                <li><a href="#works">Works</a></li>
                <li><a href="#teams">Our Team</a></li>
                <li><a href="#testimonials">Testimonials</a></li>
              </ul>
            </nav>
            <a href="#" className="nav-toggle">Menu<span></span></a>
          </div>
        </header>
      </section>
    );
  }
}
